import styled from '@emotion/styled';

import { focusRing, hoverable } from '@/shared/design-system';

export const StoreBadgeLink = styled('a')(({ theme }) => ({
  display: 'inline-flex',
  borderRadius: theme.radius[8],
  ...hoverable(theme, 'lift'),
  ...focusRing(theme, { inset: false }),

  '& svg': { width: 144, height: 48 },
}));
